import React from 'react';

interface PluginSectionProps {
  apiKey: string;
  pluginVersion: { version: string; releaseDate: string; changelog: string[] } | null;
  isLoggedIn: boolean;
}

const PluginSection: React.FC<PluginSectionProps> = ({ apiKey, pluginVersion, isLoggedIn }) => {
  return (
    <div className="plugin-section">
      <div className="plugin-config-container">
        <div className="api-key-display">
          <h2>Your API Key</h2>
          <div className="session-id">
            {isLoggedIn ? (apiKey || 'Loading...') : 'Sign in to get your API key'}
          </div>
          <p>Configure your KOReader TTS plugin with this API key. Don't share it with anyone.</p>
        </div>

        <div className="installation-guide">
          <h3>
            Plugin Installation
            {pluginVersion && (
              <span className="version-badge">
                v{pluginVersion.version} ({pluginVersion.releaseDate})
              </span>
            )}
          </h3>

          <div className="install-guide-content">
            <ol>
              <li>Download the plugin: <a href="/aloudit-plugin.zip" download>aloudit-plugin.zip</a></li>
              <li>Unzip the downloaded file</li>
              <li>Copy the <code>aloudit.koplugin</code> folder to your KOReader plugins directory</li>
              <li>Inside the folder you should see: <code>_meta.lua</code>, <code>main.lua</code>, and <code>aloudit_menubuilder.lua</code></li>
              <li>Restart KOReader</li>
              <li>Configure the plugin (Find "Aloudit" in the Tools Menu on Koreader and then "Configure API key")</li>
              <li>Set a TTS Configuration on the website</li>
              <li>For more details, see the <a href="https://koreader.rocks/user_guide/#L1-plugins" target="_blank" rel="noopener noreferrer">official KOReader plugin installation docs</a></li>
            </ol>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PluginSection;
